import React from 'react';

import { Typography } from '@mui/material';
import LabelCDS from '@sharedCR/coreDesignSystem/LabelCDS';
import { LabelSize } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';

import { RELIABILITY_LABEL_VARIANT } from '../../Declarations/Finances/CreditReportEventDates/CreditReportEventDates.constants';

import { DerogatoryEventsColumn } from './DerogatoryEventsTable.constants';

const renderText = value => <Typography variant="regular14">{value}</Typography>;

export const derogatoryEventsTableConfig = {
  [DerogatoryEventsColumn.EVENT]: {
    label: 'Event',
    content: ({ event }) => renderText(event),
    isPermanent: false,
  },
  [DerogatoryEventsColumn.DATES]: {
    label: 'Dates',
    content: ({ dates }) => renderText(dates),
    isPermanent: false,
  },
  [DerogatoryEventsColumn.RELIABILITY]: {
    label: 'Reliability',
    content: ({ reliability }) =>
      reliability ? (
        <LabelCDS
          size={LabelSize.S}
          title={reliability}
          variant={RELIABILITY_LABEL_VARIANT[reliability]}
        />
      ) : (
        '-'
      ),
    isPermanent: false,
  },
  [DerogatoryEventsColumn.SOURCE]: {
    label: 'Source',
    content: ({ source }) => renderText(source),
    isPermanent: false,
  },
  [DerogatoryEventsColumn.DETAILS]: {
    label: 'Details',
    content: ({ details }) => renderText(details),
    isPermanent: false,
  },
};
